/**
 * Query mode selector - compliance vs insight
 */

import React from 'react';
import { useChatStore } from '../../stores/chat';
import { Shield, Lightbulb, Sparkles } from 'lucide-react';
import { clsx } from 'clsx';

export function QueryModeSelector() {
  const { queryMode, setQueryMode } = useChatStore();

  const modes = [
    { value: 'auto', label: 'Auto', icon: Sparkles, desc: 'Auto-detect mode' },
    { value: 'compliance', label: 'Compliance', icon: Shield, desc: 'SOP/regulatory only' },
    { value: 'insight', label: 'Insight', icon: Lightbulb, desc: 'Includes feedback' },
  ] as const;

  return (
    <div className="flex gap-2">
      {modes.map((mode) => {
        const Icon = mode.icon;
        const isActive = queryMode === mode.value;
        
        return (
          <button
            key={mode.value}
            onClick={() => setQueryMode(mode.value)}
            className={clsx(
              'flex items-center gap-2 px-4 py-2 rounded-lg border transition-colors',
              isActive
                ? 'bg-primary-50 border-primary-500 text-primary-700'
                : 'bg-white border-gray-300 text-gray-700 hover:border-primary-300'
            )}
            title={mode.desc}
          >
            <Icon className="h-4 w-4" />
            <span className="text-sm font-medium">{mode.label}</span>
          </button>
        );
      })}
    </div>
  );
}


